import { render, staticRenderFns } from "./merchantSettlement.vue?vue&type=template&id=1a89e39a&scoped=true&"
import script from "./merchantSettlement.vue?vue&type=script&lang=js&"
export * from "./merchantSettlement.vue?vue&type=script&lang=js&"
import style0 from "./merchantSettlement.vue?vue&type=style&index=0&id=1a89e39a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a89e39a",
  null
  
)

export default component.exports